export const GET_CUSTOMER_SUBSCRIPTIONS_LIST_START = 'GET_CUSTOMER_SUBSCRIPTIONS_LIST_START';
export const GET_CUSTOMER_SUBSCRIPTIONS_LIST_SUCCESS = 'GET_CUSTOMER_SUBSCRIPTIONS_LIST_SUCCESS';
export const GET_CUSTOMER_SUBSCRIPTIONS_LIST_FAILED = 'GET_CUSTOMER_SUBSCRIPTIONS_LIST_FAILED';

export const GET_CUSTOMER_SUBSCRIPTION_START = 'GET_CUSTOMER_SUBSCRIPTION_START';
export const GET_CUSTOMER_SUBSCRIPTION_SUCCESS = 'GET_CUSTOMER_SUBSCRIPTION_SUCCESS';
export const GET_CUSTOMER_SUBSCRIPTION_FAILED = 'GET_CUSTOMER_SUBSCRIPTION_FAILED';

export const EDIT_CUSTOMER_SUBSCRIPTION_START = 'EDIT_CUSTOMER_SUBSCRIPTION_START';
export const EDIT_CUSTOMER_SUBSCRIPTION_SUCCESS = 'EDIT_CUSTOMER_SUBSCRIPTION_SUCCESS';
export const EDIT_CUSTOMER_SUBSCRIPTION_FAILED = 'EDIT_CUSTOMER_SUBSCRIPTION_FAILED';

export const EDIT_CUSTOMER_SUBSCRIPTION_PRICE_START = 'EDIT_CUSTOMER_SUBSCRIPTION_PRICE_START';
export const EDIT_CUSTOMER_SUBSCRIPTION_PRICE_SUCCESS = 'EDIT_CUSTOMER_SUBSCRIPTION_PRICE_SUCCESS';
export const EDIT_CUSTOMER_SUBSCRIPTION_PRICE_FAILED = 'EDIT_CUSTOMER_SUBSCRIPTION_PRICE_FAILED';

export const GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_START = 'GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_START';
export const GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS = 'GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS';
export const GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED = 'GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED';

export const EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_START = 'EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_START';
export const EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS = 'EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS';
export const EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED = 'EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED';

export const GET_CUSTOMER_SUBSCRIPTION_SHIPPING_START = 'GET_CUSTOMER_SUBSCRIPTION_SHIPPING_START';
export const GET_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS = 'GET_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS';
export const GET_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED = 'GET_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED';

export const GET_SUBSCRIPTION_STORE_PICKUP_ADDRESS_START = 'GET_SUBSCRIPTION_STORE_PICKUP_ADDRESS_START';
export const GET_SUBSCRIPTION_SOTRE_PICKUP_ADDRESS_SUCCESS = 'GET_SUBSCRIPTION_SOTRE_PICKUP_ADDRESS_SUCCESS';
export const GET_SUBSCRIPTION_STORE_PICKUP_ADDRESS_FAILED = 'GET_SUBSCRIPTION_STORE_PICKUP_ADDRESS_FAILED';

export const EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_START = 'EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_START';
export const EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS = 'EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS';
export const EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED = 'EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED';

export const GET_CUSTOMER_SUBSCRIPTION_HISTORY_START = 'GET_CUSTOMER_SUBSCRIPTION_HISTORY_START';
export const GET_CUSTOMER_SUBSCRIPTION_HISTORY_SUCCESS = 'GET_CUSTOMER_SUBSCRIPTION_HISTORY_SUCCESS';
export const GET_CUSTOMER_SUBSCRIPTION_HISTORY_FAILED = 'GET_CUSTOMER_SUBSCRIPTION_HISTORY_FAILED';

export const BILL_CUSTOMER_SUBSCRIPTION_START = 'BILL_CUSTOMER_SUBSCRIPTION_START';
export const BILL_CUSTOMER_SUBSCRIPTION_SUCCESS = 'BILL_CUSTOMER_SUBSCRIPTION_SUCCESS';
export const BILL_CUSTOMER_SUBSCRIPTION_FAILED = 'BILL_CUSTOMER_SUBSCRIPTION_FAILED';

export const DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_START = 'DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_START';
export const DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_SUCCESS = 'DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_SUCCESS';
export const DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_FAILED = 'DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_FAILED';

export const getCustomerSubscriptionsListStart = () => ({
  type: GET_CUSTOMER_SUBSCRIPTIONS_LIST_START,
});

export const getCustomerSubscriptionsListSuccess = (data) => ({
  type: GET_CUSTOMER_SUBSCRIPTIONS_LIST_SUCCESS,
  data
});

export const getCustomerSubscriptionsListFailed = (error) => ({
  type: GET_CUSTOMER_SUBSCRIPTIONS_LIST_FAILED,
  error
});

export const getCustomerSubscriptionStart = () => ({
  type: GET_CUSTOMER_SUBSCRIPTION_START,
});

export const getCustomerSubscriptionSuccess = (data) => ({
  type: GET_CUSTOMER_SUBSCRIPTION_SUCCESS,
  data
});

export const getCustomerSubscriptionFailed = (error) => ({
  type: GET_CUSTOMER_SUBSCRIPTION_FAILED,
  error
});

export const editCustomerSubscriptionStart = () => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_START
});

export const editCustomerSubscriptionSuccess = (data) => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_SUCCESS,
  data
});

export const editCustomerSubscriptionFailed = (error) => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_FAILED,
  error
});

export const editCustomerSubscriptionPriceStart = () => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_PRICE_START
});

export const editCustomerSubscriptionPriceSuccess = (data) => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_PRICE_SUCCESS,
  data
});

export const editCustomerSubscriptionPriceFailed = (error) => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_PRICE_FAILED,
  error
});

export const getCustomerSubscriptionBillingInfoStart = () => ({
  type: GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_START
});

export const getCustomerSubscriptionBillingInfoSuccess = (data) => ({
  type: GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS,
  data
});

export const getCustomerSubscriptionBillingInfoFailed = (error) => ({
  type: GET_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED,
  error
});

export const editCustomerSubscriptionBillingInfoStart = () => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_START
});

export const editCustomerSubscriptionBillingInfoSuccess = (data) => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_SUCCESS,
  data
});

export const editCustomerSubscriptionBillingInfoFailed = (error) => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_BILLING_INFO_FAILED,
  error
});

export const getCustomerSubscriptionShippingStart = () => ({
  type: GET_CUSTOMER_SUBSCRIPTION_SHIPPING_START
});

export const getCustomerSubscriptionShippingSuccess = (data) => ({
  type: GET_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS,
  data
});

export const getCustomerSubscriptionShippingFailed = (error) => ({
  type: GET_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED,
  error
});

export const getSubscriptionStorePickupAddressStart = () => ({
  type: GET_SUBSCRIPTION_STORE_PICKUP_ADDRESS_START
});

export const getSubscriptionStorePickupAddressSuccess = (data) => ({
  type: GET_SUBSCRIPTION_SOTRE_PICKUP_ADDRESS_SUCCESS,
  data
});

export const getSubscriptionStorePickupAddressFailed = (error) => ({
  type: GET_SUBSCRIPTION_STORE_PICKUP_ADDRESS_FAILED,
  error
});

export const editCustomerSubscriptionShippingStart = () => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_START,
});

export const editCustomerSubscriptionShippingSuccess = (data) => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_SUCCESS,
  data
});

export const editCustomerSubscriptionShippingFailed = (error) => ({
  type: EDIT_CUSTOMER_SUBSCRIPTION_SHIPPING_FAILED,
  error
});

export const getCustomerSubscriptionHistoryStart = () => ({
  type: GET_CUSTOMER_SUBSCRIPTION_HISTORY_START
});

export const getCustomerSubscriptionHistorySuccess = (data) => ({
  type: GET_CUSTOMER_SUBSCRIPTION_HISTORY_SUCCESS,
  data
});

export const getCustomerSubscriptionHistoryFailed = (error) => ({
  type: GET_CUSTOMER_SUBSCRIPTION_HISTORY_FAILED,
  error
});

export const billCustomerSubscriptionStart = () => ({
  type: BILL_CUSTOMER_SUBSCRIPTION_START
});

export const billCustomerSubscriptionSuccess = (data) => ({
  type: BILL_CUSTOMER_SUBSCRIPTION_SUCCESS,
  data
});

export const billCustomerSubscriptionFailed = (error) => ({
  type: BILL_CUSTOMER_SUBSCRIPTION_FAILED,
  error
});

export const downloadCustomerSubscriptionsStart = () => ({
  type: DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_START,
});

export const downloadCustomerSubscriptionsSuccess = (data) => ({
  type: DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_SUCCESS,
  data
});

export const downloadCustomerSubscriptionsFailed = (error) => ({
  type: DOWNLOAD_CUSTOMER_SUBSCRIPTIONS_FAILED,
  error
});
